/** Messages between Cue and its preview window (see preview-window.ts). Both are Cue pages on one origin. */

export const PREVIEW_CHANNEL = 'cue-preview';

export type ToPreviewWindow = { channel: typeof PREVIEW_CHANNEL; type: 'show'; doc: string | null; seq: number; title: string };

export type FromPreviewWindow =
  | { channel: typeof PREVIEW_CHANNEL; type: 'ready' }
  | { channel: typeof PREVIEW_CHANNEL; type: 'sandbox'; message: unknown };
